<template>
  <!-- 应收款明细表 -->
<div class="ti d-flex">
  <div class="d-flex-left">
    <erp-tree @node-click="nodeClick"></erp-tree>
  </div>
  <div class="d-flex-right">
    <!-- 设置 -->
    <div v-if="seup == 2" style="width: 99.8%;">
      <div style="margin-bottom: 5px;">
         <el-button @click="postAdd">保存</el-button>
         <el-button @click="tup">返回</el-button>
      </div>

      <div class="cdj_div">
        <div>{{homeName}}-收费标准设置</div>
        <div v-if="data_list_text">修改：{{data_list_text}}</div>
      </div>
      <div class="cdj_table">
        <div class="cdj_display">
          <div class="cdj_left" style="width: 100%;">
            <div class="cdj_left_display">
              <div class="cdj_left_display_background">开发商</div>
              <div class="cdj_el-input" style="display: flex;">
                <!-- <div style="margin-top: 3.2px;margin-right: 5px;">张晓婷</div> -->
                <el-input style="width: 50%;" placeholder="" v-model="developer.name" clearable :disabled="true"></el-input>
                <el-button style="margin-left: 3px;" @click="updatesc">选择</el-button>
                <div style="width: 430px;margin-top: 5px;margin-left: 3px;font-size: 12px;">(！空置房或指定默认收费对象为开发商时的收费对象) </div>
              </div>

            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">显示项目</div>
              <div class="cdj_el-input">
                  <el-checkbox  v-model="checked_up[0]" @change="checked_ups(1)" :true-label="1">显示常规收费项目</el-checkbox>
                  <el-checkbox  v-model="checked_up[1]" @change="checked_ups(2)" :true-label="2">显示仪表收费项目</el-checkbox>
                  <el-checkbox  v-model="checked_up[2]" @change="checked_ups(3)" :true-label="3">显示临时收费项目</el-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 5px;width: 99.8%;height: 600px;">
        <el-table :data="chargeitem_list" height="600" border style="width: 99.8%">
            <el-table-column prop="chargeitem_type" label="收费类型" width="180"></el-table-column>
            <el-table-column prop="chargeItem_name" label="收费项目" width="180"></el-table-column>
            <el-table-column prop="" label="选" width="80">
              <template slot-scope="scope">
                <!-- 多选框 -->
                <el-checkbox  v-model="checked_list['checked'+scope.$index]" @change="checked_scope(scope.row.id,scope.$index)" :true-label='scope.row.id'></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column label="收费标准">
              <template slot-scope="scope">
                <el-select v-model="chargeitem_list[scope.$index].charge_id" @change="charges(chargeitem_list[scope.$index].charge_id,scope.$index)" v-if="chargeitem_list[scope.$index].charge_id" placeholder="请选择">
                    <el-option
                      v-for="item in scope.row.checked"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="单价" width="80"></el-table-column>
            <el-table-column label="开始日期" width="150">
              <template slot-scope="scope">
                <el-date-picker v-if="chargeitem_list[scope.$index].charge_id"  style="width: 135px;" v-model="chargeitem_list[scope.$index].begin_date" type="date"></el-date-picker>
              </template>
            </el-table-column>
            <el-table-column label="结束日期" width="150">
              <template slot-scope="scope">
                <el-date-picker v-if="chargeitem_list[scope.$index].charge_id" style="width: 135px;" v-model="chargeitem_list[scope.$index].end_date" type="date"></el-date-picker>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="默认收费对象" width="200">
              <template slot-scope="scope">
                <RadioGroup v-model="chargeitem_list[scope.$index].customer_type" v-if="chargeitem_list[scope.$index].charge_id">
                    <Radio label="开发商"></Radio>
                    <Radio label="业主"></Radio>
                    <Radio label="租户"></Radio>
                </RadioGroup>
              </template>
            </el-table-column>
          </el-table>
      </div>
    </div>
    <!-- 列表 -->
    <div v-if="seup == 1">
        <div style="margin-bottom: 5px;">
           <el-button @click="searchs">搜索</el-button>
           <el-button @click="setup_list">批量设置</el-button>
           <el-button @click="updates">修改设置</el-button>
           <el-button @click="updates_list">全部修改</el-button>
           <el-button @click="del">删除</el-button>
           <el-button @click="del_list">全部删除</el-button>
           <el-button @click="excel">导出未设置标准的房产</el-button>
         </div>
         <div class="cdj_div">查询条件</div>
         <div class="cdj_table">
           <div class="cdj_display">
             <div class="cdj_left">
               <div class="cdj_left_display">
                 <div class="cdj_left_display_background">费用类型</div>
                 <div class="cdj_el-input">
                   <el-select
                       v-model="data.chargeitem_type_id"
                       style="width: 100%"
                       clearable
                       @change="chargeitem_types"
                       placeholder="费用类型">
                       <el-option
                         size="mini"
                         v-for="item in chargeitem_type"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
                       </el-option>
                     </el-select>
                 </div>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">收费项目</div>
                 <div class="cdj_el-input">
                   <el-select
                       v-model="data.chargeItem_name_id"
                       style="width: 100%"
                       clearable
                       @change="chargeItem_names"
                       placeholder="收费项目">
                       <el-option
                         size="mini"
                         v-for="item in chargeitem_1"
                         :key="item.id"
                         :label="item.chargeItem_name"
                         :value="item.id">
                       </el-option>
                     </el-select>
                 </div>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">收费标准</div>
                 <div class="cdj_el-input">
                   <el-select
                       v-model="data.chargeitemID"
                       style="width: 100%"
                       clearable
                       placeholder="收费标准">
                       <el-option
                         size="mini"
                         v-for="item in charge"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
                       </el-option>
                     </el-select>
                 </div>
               </div>
             </div>
             <div class="cdj_left">
               <div class="cdj_left_display">
                 <div class="cdj_left_display_background">当前房产</div>
                 <el-select
                     v-model="search"
                     class="cdj_el-input"
                     size="mini"
                     filterable
                     remote
                     clearable
                     reserve-keyword
                     placeholder="可搜索房产/客户姓名"
                     :remote-method="remoteMethod"
                     :loading="loading">
                     <el-option
                       v-for="item in selectList"
                       :key="item.id"
                       :label="item.house"
                       :value="item.house">
                     </el-option>
                   </el-select>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">启动日期</div>
                 <div class="cdj_el-input el-date-pickers">
                   <el-date-picker size="mini" v-model="startDate" type="date" placeholder="开始时间"></el-date-picker>
                   <span class="cdj_text_data">至</span>
                   <el-date-picker size="mini" v-model="endDate" type="date" placeholder="结束时间"></el-date-picker>
                 </div>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">是否停用房产</div>
                 <el-select
                     v-model="data.status"
                     class="cdj_el-input"
                     size="mini"
                     filterable
                     placeholder="是否停用房产"
                     :remote-method="remoteMethod"
                     :loading="loading">
                     <el-option
                       v-for="item in [{'id':1,'name':'请选择'},{'id':2,'name':'否'},{'id':3,'name':'是'}]"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
                     </el-option>
                   </el-select>
               </div>
             </div>
           </div>
         </div>
         <div style="margin-top: 5px;"></div>
         <el-table ref="multipleTable" :data="desserts" border tooltip-effect="dark" style="width: 100%" height="47vh" @selection-change="handleSelectionChange">
           <el-table-column type="selection" width="55"></el-table-column>
           <el-table-column prop="id" label="ID" width="80"></el-table-column>
           <el-table-column prop="address" label="房产" show-overflow-tooltip></el-table-column>
           <el-table-column prop="ChargeItemTypeID" label="费用类型" width="170"></el-table-column>
           <el-table-column prop="chargeItem_name" label="收费项目" width="130"></el-table-column>
           <el-table-column prop="meter_number" label="仪表编号" width="120"></el-table-column>
           <el-table-column prop="charge_name" label="收费标准" width="200"></el-table-column>
           <el-table-column prop="price" label="单价" width="60"></el-table-column>
           <el-table-column prop="begin_date" label="开始日期" width="100"></el-table-column>
           <el-table-column prop="end_date" label="结束日期" width="100"></el-table-column>
         </el-table>
         <div class="pages" v-if="desserts">
           <Page :total="total" :page-size="page" @on-change="change"  show-total />
         </div>
         <div class="zhanwu" v-else>没有数据</div>
       </div>
    </div>

    <!-- 弹窗选择用户 -->
    <Modal
      v-model="modal1"
      width="800"
      title="选择客户"
      @on-ok="roomUser">
      <div>
        <room-user style="height: 600px;" ref="child" :house="house"></room-user>
      </div>
    </Modal>
</div>

</template>

<script>
import imgurl from "../../../../assets/js/imgurl.js";
export default {
  name: "FormsOweMoney",
  data () {
    return {
      modal1:false,
      seup:1,
      checkeds:'',
      checked:[],
      checked_list:[],
      selectList:[],
      checked_up:[],
      project_id:'',
      radio:'1',
      startDate:'',
      endDate:'',
      chargeitem:[],
      chargePercentage:'',
      chargePercentage1:'',
      buttonSize:'1',
      money:'--',
      loading:false,
      desserts: '',
      total:0,
      page:12,
      search:'',
      state:0,
      chargeitem_list:[],
      data:{
        pid:'',
        house_id:'',
        homeName:'',
        startDate:'',
        endDate:'',
        chargeitemID:[],
        chargeitem_type_id:'',
        chargeItem_name_id:'',
        status:2,
      },
      chargeitem_type:[],
      chargeitem_1:[],
      charge:[],
      data_list:[],
      data_list_text:'',
      homeName:'',
      type:'',//1批量设置、2修改保存、3全部修改
      developer:[],
      house:'',
      clicks:1,
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    this.change(1);
    //加载收费大类（费项）
    // this.$myhttp.get('admin/common/getChargeitem',{
    //   'Content-Type': 'application/json'
    //   }).then(backdata=>{
    //     this.chargeitem = backdata.data.data;
    // });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    //费项
    getChargeitem_types(){
      //this.data.pid
      this.$myhttp.get('admin/RoomSetUp/getChargeitem_type?pid='+this.data.pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.chargeitem_list = backdata.data.data;
          this.chargeitem = backdata.data.data;
      });
    },
    //导出未设置标准的房产
    excel(){
      //ERP.showLoading();
      this.$myhttp.post('admin/RoomSetUp/excel',this.data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          //ERP.hideLoading();
          if(backdata.data.code == 200){
            let url = imgurl + backdata.data.data;
            window.open(url, "_blank");
          }else{
             this.$Message.success(backdata.data.message);
          }
      });
    },
    //选择开发商
    updatesc(){
      this.modal1 = true;
    },
    //点击开发商
    roomUser(){
      this.developer = this.$refs.child.getUser();
    },
    //点击费用类型
    chargeitem_types(){
      this.$myhttp.get("admin/RoomSetUp/chargeitem_type?chargeitem_type="+this.data.chargeitem_type_id,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.chargeitem_1 = backdata.data.data;
      });
    },
    //点击收费项目
    chargeItem_names(){
      this.$myhttp.get("admin/RoomSetUp/chargeItem_name?chargeItem_name_id="+this.data.chargeItem_name_id+"&pid="+this.data.pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.charge = backdata.data.data;
      });
    },
    //选择收费标准
    charges(id,index){
      let checked = this.chargeitem_list[index].checked;
      checked.map(req=>{
        if(req.id == id){
          this.chargeitem_list[index].price = req.charge;
        }
      })
    },
    //保存
    postAdd(){
      let chargeitem_list = [];
      this.chargeitem_list.map(req=>{
        if(req.charge_id){
          chargeitem_list.push(req);
        }
      })
      if(this.clicks == 2){
        return false;
      }
      this.clicks = 2;
      this.dates();
      //修改设置保存
      if(this.type == 2){
        let standard_id = this.data_list.map(req=>{return req.id}).join(",");
        let data = {'standard_id':standard_id,'checked_list':chargeitem_list,'developer':this.developer,'data':this.data};
        ERP.showLoading();
        this.$myhttp.post('admin/RoomSetUp/updatesAdd',data,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
            ERP.hideLoading();
            this.clicks = 1;
            if(backdata.data.code == 200){
              this.seup = 1;
              this.type = '';
              this.data_list = [];
              this.$Message.success('操作成功!');
              this.change(1);
              this.checked_ups("");//查询加载收费项目
              this.checked_list = [];//选择收费项目清空
              this.getChargeitem_types();
            }else{
              this.$Message.error(backdata.data.message);
            }
        });
      }
      //全部修改
      if(this.type == 3){
        let data = {'house':this.data_list_text,'checked_list':chargeitem_list,'developer':this.developer,'data':this.data}
        ERP.showLoading();
        this.$myhttp.post('admin/RoomSetUp/updatesAddList',data,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
            ERP.hideLoading();
            this.clicks = 1;
            if(backdata.data.code == 200){
              this.seup = 1;
              this.type = '';
              this.data_list = [];
              this.$Message.success('操作成功!');
              this.change(1);
              this.checked_ups("");//查询加载收费项目
              this.checked_list = [];//选择收费项目清空
              this.getChargeitem_types();
            }else{
              this.$Message.error(backdata.data.message);
            }
        });
      }
      //批量设置
      if(this.type == 1){
        let data = {'house':this.data_list_text,'checked_list':chargeitem_list,'developer':this.developer,'data':this.data}
        ERP.showLoading();
        this.clicks = 1;
        this.$myhttp.post('admin/RoomSetUp/setup_list',data,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
            ERP.hideLoading();
            if(backdata.data.code == 200){
              this.seup = 1;
              this.type = '';
              this.data_list = [];
              this.$Message.success('操作成功!');
              this.change(1);
              this.checked_ups("");//查询加载收费项目
              this.checked_list = [];//选择收费项目清空
              this.getChargeitem_types();
            }else{
              this.$Message.error(backdata.data.message);
            }
        });
      }
    },
    //删除
    del(){
      this.$confirm('确定要删除吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$myhttp.post('admin/RoomSetUp/del',this.checked,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
               if(backdata.data.code == 200){
                 this.change(1);
                 this.$Message.success('操作成功!');
               }else{
                 this.$Message.error(backdata.data.message);
               }
          });
        }).catch(() => {

        });
    },
    //全部删除
    del_list(){
      if(!this.data.homeName){
        this.$Message.error("点击左边树，选择需要删除的范围！");
        return false;
      }
      this.dates();
      this.$confirm('当前选择：'+this.data.homeName+'，确定要全部删除吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let list = {'homeName':this.data.homeName,'data':this.data};
          this.$myhttp.post('admin/RoomSetUp/del_list',list,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
               if(backdata.data.code == 200){
                 this.change(1);
                 this.$Message.success('操作成功!');
               }else{
                 this.$Message.error(backdata.data.message);
               }
          });
        }).catch(() => {

        });
    },
    //选择收费项
    checked_scope(id,index){
      let pid = this.data.pid;
      //console.log(id+'---'+index)
      // console.log(this.checked_list['checked'+index])
      if(this.checked_list['checked'+index] != undefined){
         this.$myhttp.get("admin/RoomSetUp/checked?pid="+pid+"&chargeitem_name="+id,{
           'Content-Type': 'application/json'
           }).then(backdata=>{
            if(backdata.data.code == 200){
              this.chargeitem_list[index].checked = backdata.data.data;
              this.chargeitem_list[index].charge_id = backdata.data.data[0].id;
              this.chargeitem_list[index].price = backdata.data.data[0].charge;
            }else{
              this.$Message.error(backdata.data.message);
              this.checked_list['checked'+index] = '';
            }
         });
      }else{
        this.chargeitem_list[index].checked = [];
        this.chargeitem_list[index].charge_id = '';
        this.chargeitem_list[index].price = '';
      }
    },
    checked_ups(id){
      id = this.checked_up.map(req=>{
        return req;
      }).join(',');
      this.$myhttp.get('admin/RoomSetUp/getChargeitem_type?ChargeItemTypeID='+id+'&pid='+this.data.pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.chargeitem_list = backdata.data.data;
      });
    },
    tup(){
      this.checked_ups("");//查询加载收费项目
      this.checked_list = [];//选择收费项目清空
      this.data_list = [];
      this.developer = [];
      this.seup = 1;
      this.getChargeitem_types();
    },
    handleSelectionChange(val) {
      this.checked={
        checked0:"",
        checked1:"",
        checked2:"",
        checked3:"",
        checked4:"",
        checked5:"",
        checked6:"",
        checked7:"",
        checked8:"",
        checked9:"",
        checked10:"",
        checked11:"",
      };
      let order = val;
      order.map((req,index)=>{
        if(index == 0){
          this.checked.checked0 = req.id;
        }
        if(index == 1){
          this.checked.checked1 = req.id;
        }
        if(index == 2){
          this.checked.checked2 = req.id;
        }
        if(index == 3){
          this.checked.checked3 = req.id;
        }
        if(index == 4){
          this.checked.checked4 = req.id;
        }
        if(index == 5){
          this.checked.checked5 = req.id;
        }
        if(index == 6){
          this.checked.checked6 = req.id;
        }
        if(index == 7){
          this.checked.checked7 = req.id;
        }
        if(index == 8){
          this.checked.checked8 = req.id;
        }
        if(index == 9){
          this.checked.checked9 = req.id;
        }
        if(index == 10){
          this.checked.checked10 = req.id;
        }
        if(index == 11){
          this.checked.checked11 = req.id;
        }
      })
    },
    //修改设置
    updates(){
      ERP.showLoading();
      this.$myhttp.post('admin/RoomSetUp/updates',this.checked,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          ERP.hideLoading();
          let data = backdata.data.data;
          if(backdata.data.code == 200){
            this.data_list = data;
            this.data_list_text = data.map(req=>{return req.address}).join("，");
            this.seup = 2;
            this.type = 2;
            this.homeName = this.data.homeName;
          }else{
            this.$Message.error(backdata.data.message);
          }
      });
    },
    //全部修改
    updates_list(){
      if(this.data.pid == ''){
        this.$Message.error("项目不能为空，点击左边树");
        return false;
      }
      this.seup = 2;
      this.type = 3;
      this.homeName = this.data.homeName;
      this.data_list_text = this.data.homeName;
    },
    //批量设置
    setup_list(){
      if(this.data.pid == ''){
        this.$Message.error("项目不能为空，点击左边树");
        return false;
      }
      this.seup = 2;
      this.type = 1;
      this.homeName = this.data.homeName;
      this.data_list_text = this.data.homeName;
    },
    remoteMethod(query){
      if (query !== '') {
        // console.log(query);
        this.loading = true;
        this.$myhttp.get('admin/common/house_text?text='+query+'&project_id='+this.project_id,{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.selectList = backdata.data.data;
            this.loading = false;
        });
      } else {
        this.selectList = [];
      }
    },
    //获得当前多少页,分页
    change(e){
      this.dates();
      ERP.showLoading()
      this.data.page = e;
      this.$myhttp.post('admin/RoomSetUp/index',this.data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          let data = backdata.data.data;
          this.desserts = data.data;
          this.total = data.count;
          this.page = data.pageSize;
          this.chargeitem_type = data.chargeitem_type;
          ERP.hideLoading()
      });
      this.checkeds = false;
      this.checked={
        checked0:"",
        checked1:"",
        checked2:"",
        checked3:"",
        checked4:"",
        checked5:"",
        checked6:"",
        checked7:"",
        checked8:"",
        checked9:"",
        checked10:"",
        checked11:"",
      };
    },
    //时间转换
    dates(){
      this.data.startDate = '';
      this.data.endDate = '';
      if(this.startDate != null && this.startDate != ''){
        let d = this.startDate;//开始时间
        let startDate = new Date(d).getTime()/1000;
        startDate = Number(startDate).toFixed(0);
        this.data.startDate = startDate;
      }
      if(this.endDate != null && this.endDate != ''){
        let d = this.endDate;//开始时间
        let endDate = new Date(d).getTime()/1000;
        endDate = Number(endDate).toFixed(0);
        this.data.endDate = endDate;
      }
    },

    //搜索
    searchs(){
      this.change(1);
    },
    // 树组件点击触发
    nodeClick(data) {
      let project = data.tree[0];
      this.project_id = project.pindex_id;
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      //console.log(data.tree)
      this.data.pid = data.tree[0]['id'];
      this.data.homeName=tree_str;
      // this.change(1);
      this.data.house_id = '';
      this.search=tree_str;
      if(data.tree[data.tree.length-1].type==='room'){
        this.data.house_id = data.tree[data.tree.length-1].id;
      }
      this.change(1);
      this.getChargeitem_types();
    }
  },
  watch:{
    "search"(e){
      let _this = this;
      _this.data.homeName=e;
      let list = _this.selectList;
      list.map(function(it){
        if(e == it.house){
          _this.data.house_id = it.id;
        }
      })
    }
  },

  components: {
    "erp-tree": () => import('../../Common/erp-tree.vue'),
    "room-user": () => import('../../Common/room-user.vue')
  },

}
</script>
<style scoped>
@import '../../../../assets/css/table.css';
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin{
  margin-left:1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/room/RoomSetUp.vue